import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getUserData} from '@/auth/utils'

export default function useCategoriesList(){

    const toast = useToast()

    const refCategoryListTable = ref(null)
    const refCategoryCategoryListTable = ref(null)


    const tableColumns = computed(() => {
        let user_id =  getUserData().id
        let column = [
            {key:'name', label:'Name'},
            {key:'description', label:'Description'},
            {key:'actions'}
        ];

        if(user_id == 1){
            column = [
                {key:'name', label:'Name'},
                {key:'description', label:'Description'},
                {key:'user.name', label:'COMPANY'},
                {key:'actions'}
            ]; 
        }
        return column;
    })

    const categoryTableColumns = [
        {key:'label', label:'name'},
        {key:'actions'}
    ]
    const perPage = ref(10)
    const totalCategories = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const categoryOptions = ref([])
    const userFilter = ref(null)
    

    const dataMeta = computed(() => {
        const localItemsCount = refCategoryListTable.value ? refCategoryListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCategories.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refCategoryListTable.value.refresh()
    }

    const getCategoryImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery, userFilter], () => {
        refetchData()
    })

    const userOptions = ref([])

    const fetchOptions = () => {
        store
        .dispatch("app/fetchOptions", {
            users: true
        })
        .then(response => {
            userOptions.value = response.data.users
        })
        .catch(() => {
           console.log('Error fetching options')
        })
    }

    const fetchCategories = (ctx, callback) => {

        store.dispatch('bar-category/fetchCategories', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            user_id: userFilter.value
        })
        .then(response => {
            //console.log(response.data)
            const { categories, total} = response.data
            callback(categories)
            totalCategories.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching categories list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }

    onMounted(() => {
        fetchOptions()
    })

    return {
        fetchCategories,
        tableColumns,
        categoryTableColumns,
        perPage,
        currentPage,
        totalCategories,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refCategoryListTable,
        refCategoryCategoryListTable,
        getCategoryImage,
        categoryOptions,
        showMessage,
        userOptions,
        userFilter
    
        //Extra Filters
    }

}